import React, { useState } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { Typography, Divider } from '@mui/material';
import { TextInput, PasswordInput } from '../../../components/TextFields';
import { useAlert } from '../../../components/Notification';
import { hashPassword } from '../../../constant/constant';

import { handlePasswordReset } from '../../../stores/services/authApis/index';

interface ResetProps {
  email: string;
}

const ResetPassword: React.FC<ResetProps> = ({ email }) => {
  const navigate = useNavigate();
  const showAlert = useAlert();
  const [otp, setOtp] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isOtpValid, setisOtpValid] = useState(false);
  const [isPasswordValid, setisPasswordValid] = useState(false);
  const [isConfirmPasswordValid, setisConfirmPasswordValid] = useState(false);

  const Reset = async () => {
    await handlePasswordReset({
      userEmail: email,
      resetInfo: {
        otp: otp ? Number(otp) : otp,
        password: hashPassword(password),
      },
    })
      .then(() => {
        showAlert('Password reset Successfully', 'success');
        navigate('/login');
      })
      .catch(() => {
        showAlert('Invalid OTP', 'error');
      });
  };

  return (
    <>
      <div className="form_header">
        <Typography variant="h5" align="center" fontWeight="bold">
          OTP
        </Typography>
        <Typography align="center" variant="body2">
          <p className="form-instructions">
            A digit code has been sent to your
          </p>
        </Typography>
        <Typography align="center" variant="body2">
          <p className="form-instructions routerLink">{email}</p>
        </Typography>
      </div>
      <div className="auth_form">
        <div className="auth_formitem">
          <div className="form-input">
            <PasswordInput
              value={password}
              handleValid={setisPasswordValid}
              onChange={setPassword}
              error={isPasswordValid}
            />
          </div>

          <div className="form-input">
            <PasswordInput
              label="Confirm Password"
              value={confirmPassword}
              handleValid={setisConfirmPasswordValid}
              onChange={setConfirmPassword}
              error={isConfirmPasswordValid}
            />
          </div>
          <div className="form-input">
            <TextInput
              name="otp"
              id="otp"
              label="Enter OTP"
              type="number"
              required={true}
              placeholder="Ex 179452"
              value={otp}
              handleValid={setisOtpValid}
              onChange={setOtp}
              error={isOtpValid}
              minLength={4}
              maxLength={6}
            />
          </div>
        </div>
        <Divider component="div" role="presentation" />
        <div className="auth_formitem">
          <button
            className="submit_Button"
            disabled={
              !(isOtpValid && isPasswordValid && isConfirmPasswordValid)
            }
            color="primary"
            onClick={() => {
              Reset();
            }}
          >
            Reset Your Password
          </button>
          <Typography
            variant="body2"
            align="center"
            className="submit_Button-text"
          >
            Don&apos;t remember you email? <br />
            <RouterLink className="routerLink" to="/forgot-password">
              Contact Support
            </RouterLink>
          </Typography>
        </div>
      </div>
    </>
  );
};

export default ResetPassword;
